import * as React from "react";
import { useMemo } from "react";
import ColorMapper from "views/components/visualizations/ColorMapper";
import useViewsDispatch from "views/stores/useViewsDispatch";
import { setChartColor } from "views/logic/slices/widgetActions";
import useColorRules from "./useColorRules";
import ChartColorContext from "../visualizations/ChartColorContext";
const WidgetColorContext = ({ children, id }) => {
  const colorRules = useColorRules();
  const colorRulesForWidget = useMemo(() => {
    const colorMapperBuilder = ColorMapper.builder();
    const colorRulesForWidgetBuilder = colorRules.filter(({ widgetId }) => widgetId === id).reduce((prev, { name, color }) => prev.set(name, color), colorMapperBuilder);
    return colorRulesForWidgetBuilder.build();
  }, [colorRules, id]);
  const dispatch = useViewsDispatch();
  const contextValue = useMemo(() => {
    const setColor = (name, color) => {
      colorRulesForWidget.set(name, color);
      return dispatch(setChartColor(id, name, color));
    };
    return {
      colors: colorRulesForWidget,
      setColor
    };
  }, [colorRulesForWidget, dispatch, id]);
  return /* @__PURE__ */ React.createElement(ChartColorContext.Provider, { value: contextValue }, children);
};
export default WidgetColorContext;
